module.exports = __webpack_public_path__ + "img/partners.9222b431.jpeg";